import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Map, List } from "immutable";
import { Row, Col, Card, Button, Select, message, Table, Input, InputNumber, Spin } from "antd";
import { formatCurrency } from "utilities/currency";
import CibilReportTable from "./cibil-report-table";
import BundledLimitAssignment from "./bundled-limit-assignment";
import ExistingBankLimitsList from "./existing-bank-limits-list";
import SalesDataList from "./sales-data-list";
import SalesAnalysisTradeYear from "./sales-analysis-trade-year";
import TotalRepayment from "./total-repayment";
import BankStatementAnalysisTab from "./bank-statement-analysis-tab";
import RemarksEditor from "./remarks-editor";
import InnerRemarksEditor from "./inner-remarks-editor";
import CreditAppraisalProposedLimit from "./credit-appraisal-proposed-limit";
import CreditAppraisalGstinPull from "./credit-appraisal-gstin-pull";
import CreditAppraisalDateOfAppointment from "./credit-appraisal-date-of-appointment";
import CreditAppraisalDateOfIncorporation from "./credit-appraisal-date-of-incorporation";
import { UI_PERMISSIONS } from "constants/index";
import TopBrandsTable from "./top-brands-table";
import { CompanyService } from "services";
import { LOAN_TRACK_OPTIONS, POTENTIAL_RISK_PARAMETERS } from "constants/enums";
import LedgerMasterData from "./ledger-master-table";
import GSTFillingStatus from "./gstin-filling-status";
import CibilParamTable from "./cibil-parameter-table";
import Trackwizz from "./trackwizz";
import TrackwizzContinuousScreening from "./trackwizz-continous-screening";
import ReCreditParameterTable from "./re-credit-parameters.js";
// import questionareList from "../questionare-list";
// import QuestionareList from "./questionare-list";
import {
    updateCompanyAssociates,
    updateCompanyBankAccounts,
    createStatement,
    fetchStatement,
    updateStatement,
    deleteStatement,
    fetchCaseSupplyChainFinancials,
    updateCaseDetail,
    fetchCaseDetailFields,
    updateCaseDetailFields,
    updateCaseRemarks,
    fetchFinancialYears,
    fetchChannelProductStats,
    updateChannelProductStats,
    addNewChannelProduct,
    updateCompanyAssociatesCibil,
    fetchCompanyGstinFillingDetails,
    refreshCompanyGstinFillingDetails,
    attachDocument,
    createRequest,
    createProfiosRequest,
    fetchJobsList,
    fetchJobsDetails,
    fetchJobsDetailsPerfios,
    fetchStatementAnalysis,
    fetchStatementAnalysisPerfois,
    retryAnalysis,
    retryAnalysisPerfios,
    addCaseAssociates,
    fetchCaseRemarks
} from "store/actions";
import { STATE_STATUS } from "../../constants";
import companyService from "../../services/company-service";
const { TextArea } = Input;
import ApprovalParameters from "./approval-parameters";
import OverdueAccountDetails from "./overdue-account-details";
import EligibilityCalculator from "./eligibility-calculator";
import WctlBlFields from "./wctl-bl-fields";
import { CaseService } from "../../services";


const columnsEnhancementPolicyPara = [
    { title: "S.No.", dataIndex: "s_no", key: "s_no", align: "center", width: "5%" },
    {
        title: "Parameters for Buyer", dataIndex: "par_db", key: "par_db", align: "center", width: "40%",
        render: (text) => {
            return {
                props: {
                    style: { textAlign: "start" },
                },
                children: <div>{text}</div>
            };
        }
    },
    {
        title: "Value", dataIndex: "value", key: "value", align: "center", width: "40%",
        render: (text, record) => {
            return {
                props: {
                    style: {
                        background:
                            record?.pass_fail_output === "Pass" ? "#20D66947" : record?.pass_fail_output === "Fail" ? "#D32A2A33" : "#D9D9D961",
                        border: ["Pass", "Fail"].includes(record?.pass_fail_output) ? "1px solid rgb(215 218 227)" : "1px solid rgb(226 229 235)"
                    },
                },
                children: <div>{text}</div>
            };
        }
    },
];

const buyerExposureTableColumns = [
    {
        title: "Product Type",
        dataIndex: "business_product_type",
    },
    {
        title: "Sanctioned Limit",
        dataIndex: "sanction_limit",
        render: _ => formatCurrency(_, false)
    },
    {
        title: "Adhoc Limit",
        dataIndex: "adhoc_limit",
        render: _ => formatCurrency(_, false)
    },
    {
        title: "Current OS",
        dataIndex: "total_receivable",
        render: _ => formatCurrency(_, false)
    },
    {
        title: "# Churn",
        dataIndex: "churn",
        render: _ => formatCurrency(_, false)
    },
    {
        title: "OD invoices",
        dataIndex: "od_invoices",
        render: _ => formatCurrency(_, false)
    },
    {
        title: "Max DPD in LTM",
        dataIndex: "max_dpd_12m",
        render: _ => formatCurrency(_, false)
    },
    {
        title: "% of OD invoices",
        dataIndex: "prcn_od_invoices",
        render: _ => formatCurrency(_, false)
    },
    {
        title: "% of OD>30 dpd in LTM",
        dataIndex: "prcn_od_30_ltm_invoices",
        render: _ => formatCurrency(_, false)
    },
    {
        title: "Group limit",
        dataIndex: "group_limit",
    },
];

const columns = [
    {
        title: "Turnover in Financial Year",
        dataIndex: "key_name",
        key: "key_name",
    },
    {
        title: "Declared during PD (in lakhs)",
        dataIndex: "total_sales",
        key: "total_sales",
    },
    {
        title: "As per GST Slab",
        dataIndex: "gst_slab",
        key: "gst_slab",
    },
];

const dataSource = [
    {
        key: "1",
        key_name: "FY 21-22",
        total_sales: "",
        gst_slab: "",
    },
    {
        key: "2",
        key_name: "FY 22-23",
        total_sales: "",
        gst_slab: "",
    },
    {
        key: "2",
        key_name: "YTD FY 23-24",
        total_sales: "",
        gst_slab: "",
    },
];

class CreditAppraisalTab extends React.Component {
    state = {
        proposed_limit: 0,
        channel_products: [],
        loan_track: this.props.caseDetail && this.props.caseDetail.loan_track,
        cibilDocuments: [],
        cibilParameter: [],
        dataEnhancementPolicyPara: [],
        loading: false,
        gstSlabData: dataSource,
        reCreditParams: {},
        calculatorData: {}, 
        riskParameter: [],
        remarksPotentialRisk: "",
        trackwizzData:[],
        downloadExcelLoader : false,
        assessmentInputs: {
            commercialBureauScore: null,
            overlimitCCOD: null,
            customerTransactions: null,
            banking_turnover_stated_with_anchor_purchase: null
        },
        trackwizzContinuousScreeningData: [],
        buyerExposureData: [],
        buyerExposureLoader: true
    };

    fetchBuyerExposure = () => {
        this.setState({ buyerExposureLoader: true });
        CompanyService.getCaseBuyerExposure(this.props.caseId)
            .then((res) => {
                this.setState({
                    buyerExposureData: res?.data?.data || [],
                    buyerExposureLoader: false
                });
            })
            .catch(() => {
                this.setState({ buyerExposureLoader: false });
            });
    }

    renderLimitInfoCard = () => {
        return (
            <Card
                className="case_detail_card card-align-center"
                bodyStyle={{ padding: "10px 15px" }}
                style={{ borderRadius: 7, background: "#f6ebff" }}
            >
                <Col lg={2} sm={8}>
                    <p className="text-black fw-600">Limit Info</p>
                </Col>
                <div className="d-flex  w-100">
                    <Col lg={24} xs={24} sm={24}>
                        <Card bodyStyle={{ padding: "10px 10px" }} style={{ borderRadius: 7, boxShadow: 'none' }}>
                            <Table
                                locale={{ emptyText: 'Limit Info Not Available' }}
                                bordered
                                size={"middle"}
                                columns={buyerExposureTableColumns}
                                className={"ant-col padless-card w-100"}
                                dataSource={this.state.buyerExposureData}
                                loading={this.state.buyerExposureLoader}
                                noRowSelection={false}
                                pagination={false}
                            />
                        </Card>
                    </Col>
                </div>
            </Card>
        );
    }
    componentDidUpdate() {
        if (this.props.financialsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchCaseSupplyChainFinancials(this.props.caseId);
        }
        if (this.props.financialYearsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchFinancialYears(this.props.companyId);
        }
        if (this.props.channelProductStatsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchChannelProductStats(this.props.caseId);
        }
        if (this.props.caseDetailFieldsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchCaseDetailFields(this.props.caseId);
        }

    }

    componentDidMount() {
        CompanyService.cibilCommercialParam(this.props.caseId).then(_ => {
            CompanyService.getCibilParameter(this.props.caseId).then(_ => {
                this.setState({
                    cibilParameter: _.data
                });
            });
        }).catch(err => {
            console.log("err", err);
        })
        CompanyService.camAutomation(this.props.caseId).then(({ data }) => {
        }).catch((error) => {
            console.log("error", error);
        });
        CompanyService.getChannelProducts().then(_ => {
            this.setState({
                channel_products: _.data
            });
        });

        this.creditEnhancementPolicyParametersFn();

        CompanyService.getCibilDocuments(this.props.caseId).then(_ => {
            this.setState({
                cibilDocuments: _.data && _.data.results
            });
        });

       

        this.props.fetchJobsList(this.props.caseId);
        companyService.getAnnualTurnOver(this.props.caseId).then(res => {
            const data = res.status === 200 && res.data;
            const finalData = data.map((el, key) => {
                el["key"] = key + 1 + "";
                return el;
            });
            this.setState({ gstSlabData: finalData });
        }).catch((err) => {
            console.log("inside catch gst slab", err);
        });
        companyService.getReCreditDetails(this.props.caseId).then(res => {
            const data = res.status === 200 ? res.data : {};
            this.setState({ reCreditParams: data });
        }).catch((err) => {
            console.log("inside catch gst slab", err);
        });
        CompanyService.getRetailerRisk(this.props.caseId).then(res => {
            const riskParam = res?.data?.deviation_potential_risk;
            if (res?.status === 200) {
                this.setState({
                    riskParameter: riskParam.length > 0 ? riskParam.map(el => +el) : [],
                    remarksPotentialRisk: res?.data?.deviation_remarks
                })
            }
        }).catch(err => {
            console.log("inside catch", err);
        })
        CompanyService.trackwizzEntity(this.props.companyId).then(res=>{
            this.setState({trackwizzData:res.data});
        }).catch(err=>{
            console.log("inside catch", err);
        })
        CaseService.getEligibilityCalculatorData(this.props.caseId).then(res => {
            const data = res.status === 200 ? res.data : {};
            this.setState({ calculatorData: data });
        }).catch(err => {
            console.log("Datanot found", err);
        });
        CompanyService.trackwizzContinuous(this.props.caseId)
            .then(res => {
                this.setState({ trackwizzContinuousScreeningData: res.data });
            });

        // Fetch Limit Info only when this tab is opened (mounted).
        this.fetchBuyerExposure();

    }

    creditEnhancementPolicyParametersFn = () => {
        this.setState({ loading: true });
        try {
            this.props.caseType === 2 && CompanyService.getCreditEnhancementPolicyParameters(this.props.caseId).then(({ data }) => {
                const newData = Object.values(data);
                const policyParametersData = newData.map((el, idx) => ({
                    "s_no": idx + 1,
                    "par_db": el.par_db,
                    "value": el.value,
                    "pass_fail_output": el.pass_fail_output
                }));
                this.setState({ dataEnhancementPolicyPara: policyParametersData, loading: false });
            }).catch((err) => {
                message.error(err?.non_field_error && err?.non_field_error.length && err?.non_field_error[0] || "Something went wrong");
                this.setState({ loading: false });
            });
        } catch (error) {
            console.log("inside catch", error);
            this.setState({ loading: false });
        }
    }

    callApis = () => {
        console.log("call apis");
        CompanyService.getChannelProducts().then(_ => {
            this.setState({
                channel_products: _.data
            });
        });

        CompanyService.getCibilDocuments(this.props.caseId).then(_ => {
            this.setState({
                cibilDocuments: _.data && _.data.results
            });
        });

        this.props.fetchJobsList(this.props.caseId);
    }

    financialAnalysisConditionToggle = value => {
        this.props.updateCaseDetail(
            this.props.caseId,
            this.props.caseDetail.set("is_financial_analysis_applied", value)
        );
    };

    updateTotalSales = (financial_year, total_sales) => {
        this.props.updateCaseDetailFields(this.props.caseId, {
            financial_year,
            total_sales,
        });
    };
    updateChildCaseLimit = (bundled_limit_percentage) => {
        if (bundled_limit_percentage <= 0 || bundled_limit_percentage > 100) {
            message.error("Please enter value between 1 and 100");
            return;
        }
        const loadingMessage = message.loading("Updating...", 0);
        CaseService.updateBundledLimit(this.props.caseId , {'bundled_limit_percentage' : bundled_limit_percentage})
        .then((resp) => {
            loadingMessage();
        })
        .catch((err) => {
            loadingMessage();
            message.error("Failed to update insurance status. Please try again.");
        })
    };

    onRemarksEdit = (value, isManuallySaved) => {
                this.props.updateCaseRemarks(
            this.props.caseId,
            value,
            this.props.caseInternalRemarks,
            isManuallySaved
        );
    };

    onInnerRemarksEdit = (value, isManuallySaved) => {
        this.props.updateCaseRemarks(
            this.props.caseId,
            this.props.caseRemarks,
            value,
            isManuallySaved
        );
    }

    onProposedLimitChange = value =>
        this.props.updateCaseDetailFields(
            this.props.caseId,
            { proposed_limit: value }
        );
    onDateAppointmentChange = value =>
        this.props.updateCaseDetailFields(
            this.props.caseId,
            { date_of_appointment: value && value !== "Invalid date" ? value : null }
        );
    onDateIncorporationChange = value =>
        this.props.updateCaseDetailFields(
            this.props.caseId,
            { date_of_incorporation: value && value !== "Invalid date" ? value : null }
        );
    onSalesDisplayChange = (displayYear, displayCurrency) => {
        this.props.updateCaseDetail(
            this.props.caseId,
            this.props.caseDetail
                .set("sales_analysis_display_type", Number(displayYear))
                .set("sales_analysis_display_currency", Number(displayCurrency))
        );
    };

    updateBrands = (brands) => {
        this.props.updateChannelProductStats(this.props.caseId, brands);
    }

    updateLoanTrack = () => {
        this.props.updateCaseDetail(
            this.props.caseId,
            this.props.caseDetail
                .set("loan_track", Number(this.state.loan_track))
        );
    }


    getTotalLimit() {
        const proposedLimit = +(this.props.caseDetail.proposed_limit || 0);
        const keyBankAccount = this.props.company && this.props.company.bank_accounts && this.props.company.bank_accounts.find(_ => _.is_key_account);
        if (keyBankAccount) {
            return proposedLimit + (keyBankAccount.account_limit || 0);
        }
        return proposedLimit;
    }

    updateCaseAssociates = (associateId, record) => {
        let obj = {
            id: associateId,
            ...record,
            applicable_bureau: record.bureau,
        };
        let associateTobeUpdated = this.props.caseAssociates && this.props.caseAssociates.find(_ => _.id == associateId);
        if (associateTobeUpdated) {
            obj = {
                ...associateTobeUpdated.toJS(),
                ...obj
            };
        }
        Object.keys(obj).forEach(k => {
            if (obj[k] === "") {
                obj[k] = null;
            }
        });
        this.props.addCaseAssociates(this.props.caseId, [obj], this.props.companyId);
    }

    getAssociatesData = () => {
        let caseAssociates = (this.props.caseAssociates && this.props.caseAssociates.map(_ => _.company_associate && _.company_associate.id).toArray()) || [];
        let associatesList = this.props.company && this.props.company.associates.filter(_ => caseAssociates.includes(_.id));
        associatesList = associatesList.withMutations(list =>
            list.map(_ => {
                let caseAssociateDetail = this.props.caseAssociates.find(__ => _.id == (__.company_associate && __.company_associate.id));
                if (caseAssociateDetail) {
                    return _.setIn(["case_level_data"], caseAssociateDetail);
                }
                return _;
            })
        );
        return associatesList;
    }

    updateCibilParameter = (value) => {
        let postData = { "credit_parameters": value };
        CompanyService.updateCibilParameter(this.props.caseId, postData).then(() => {
            CompanyService.getCibilParameter(this.props.caseId).then(_ => {
                this.setState({
                    cibilParameter: _.data
                });
            });
            message.success("Cibil parameter updated successfuly!");
        }).catch((err) => {
            console.log("error", err);
            message.success("Cibil parameter update failed!");
        });
    }

    getCaseRemarks = () => {
        this.props.fetchCaseRemarks(this.props.caseId);
    }

    potentialRiskFn = () => {
        const body = {
            "deviation_potential_risk": this.state.riskParameter,
            "deviation_remarks": this.state.remarksPotentialRisk
        };

        if (this.state.riskParameter && this.state.remarksPotentialRisk?.trim()) {
            CompanyService.postRetailerRisk(this.props.caseId, body).then(res => {
                if (res?.status === 200) {
                    message.success(res?.data?.message || "Retailer Level Deviation Flagging Saved.")
                }
            }).catch(err => {
                console.log("inside catch", err);
            })
        } else {
            message.error("Please fill all the fields");
        }
    }
  
    assessmentInputsFn = () => {
        const { assessmentInputs } = this.state;
        const { json_data } = this.props;
    
        const cmr_score = assessmentInputs.commercialBureauScore ?? json_data?.cmr_score;
        const overlimit_cc_od = assessmentInputs.overlimitCCOD ?? json_data?.overlimit_cc_od;
        const customer_txn = assessmentInputs.customerTransactions ?? json_data?.customer_initiated_txn_in_last_6_months;
        const  banking_turnover_stated_with_anchor_purchase = assessmentInputs.banking_turnover_stated_with_anchor_purchase ?? json_data?.banking_turnover_stated_with_anchor_purchase;
    
        if ([cmr_score, overlimit_cc_od, customer_txn, banking_turnover_stated_with_anchor_purchase].some(val => val === "" || val === null || val === undefined)) {
            message.error("All fields are mandatory. Please fill in all details.");
            return;
        }
    
        const body = {
            cmr_score: Number(cmr_score),
            overlimit_cc_od: Number(overlimit_cc_od),
            customer_initiated_txn_in_last_6_months: Number(customer_txn),
            banking_turnover_stated_with_anchor_purchase: Number(banking_turnover_stated_with_anchor_purchase)
        };

        if (this.state.assessmentInputs) {
            CompanyService.updateAssessmentReport(this.props.caseId, body).then(res => {
                if (res?.status === 200) {
                    message.success("Assessment Report Data Saved.")
                }
            }).catch(err => {
                console.log("inside catch", err);
                this.setState({
                    assessmentInputs: {
                        commercialBureauScore: json_data?.cmr_score ?? "",
                        overlimitCCOD: json_data?.overlimit_cc_od ?? "",
                        customerTransactions: json_data?.customer_initiated_txn_in_last_6_months ?? "",
                        banking_turnover_stated_with_anchor_purchase: json_data?.banking_turnover_stated_with_anchor_purchase ?? ""
                    }
                });
            })
        } else {
            message.error("Please fill all the fields");
        }
    }

    onChangeAssessmentFields = (value, field) => {
        if (value === "") {
            this.setState({
                assessmentInputs: {
                    ...this.state.assessmentInputs,
                    [field]: ""
                }
            });
            return;
        }
        if (field == 'banking_turnover_stated_with_anchor_purchase'){
            const num = parseFloat(value);
            if (isNaN(num) || num < 1 || num > 100 || !/^\d*\.?\d+$/.test(value)) {
                message.error("Please enter a valid number between 1 and 100");
                return;
            }
        }else{
            if (isNaN(value) || !/^\d+$/.test(value)) {
                message.error("Please enter a valid integer");
                return;
            }
        }
        
        
        this.setState({
            assessmentInputs: {
                ...this.state.assessmentInputs,
                [field]: value
            }
        });
    }

    onSelectRiskParam = (val) => {
        this.setState({ riskParameter: val })
    }
    downloadExcel = () => {
        this.setState({
            downloadExcelLoader: true
        })
        CompanyService.getLedgerMatchData(this.props.caseId).then(res => {
            if (res?.status === 200) {
                if(res.data.length){
                    const data = res.data;
                    const fileName = "report.csv"; // <-- Fix: define the filename

                    const headers = Object.keys(data[0]);
                    const rows = data.map(row =>
                        headers.map(h => JSON.stringify(row[h] ?? "")).join(",")
                    );
                    const csvContent = [headers.join(","), ...rows].join("\n");
                
                    // Convert to Blob
                    const blob = new Blob([csvContent], {
                        type: "text/csv;charset=utf-8;", // CSV MIME type
                    });
                
                    // Trigger download
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                }else{
                    message.error("No Data Found");
                }
                this.setState({
                    downloadExcelLoader: false
                })
        
            }
        }).catch(err => {
            this.setState({
                downloadExcelLoader: false
            })
            console.log("inside catch", err);
        })    
                
    }
    render() {
        const ksfTLFormData = Map({
            'tenor': this.props.caseDetail.getIn(['json_data','tenor_for_term_loan_from_credit'], ''),
            'roi' : this.props.caseDetail.getIn(['json_data','roi_for_term_loan_from_credit'], '')
        })
        const {
            caseId,
            companyId,
            company,
            companyStatus,
            updateCompanyBankAccounts,
            createStatement,
            fetchStatement,
            deleteStatement,
            isUserAllowedToEdit,
            updateStatement,
            statements
        } = this.props;

        if (
            !companyStatus ||
            companyStatus.get("companyStatus") !== STATE_STATUS.FETCHED
        ) {
            return "FETCHING";
        }
        return (
            <Row className={"p-5"}>
                <Row gutter={16}>
                    <Col span={5} className={"p-10"}>
                        <Spin spinning={this.props.caseDetailFieldsStatus === STATE_STATUS.FETCHING || this.props.caseDetailFieldsStatus === STATE_STATUS.UPDATING}>
                            <CreditAppraisalProposedLimit
                                proposedLimit={
                                    this.props.caseDetailFields &&
                                    this.props.caseDetailFields.get("proposed_limit")
                                }
                                isRiskApprover={this.props.isRiskApprover}
                                update={this.onProposedLimitChange}
                                isUserAllowedToEdit={isUserAllowedToEdit}
                                recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                            />
                        </Spin>
                    </Col>
                    <Col span={4} className={"p-10"}>
                        <CreditAppraisalGstinPull
                            gstin={this.props.company.gstin}
                        />
                    </Col>
                    <Col span={5} className={"p-10"}>
                        <Spin spinning={this.props.caseDetailFieldsStatus === STATE_STATUS.FETCHING || this.props.caseDetailFieldsStatus === STATE_STATUS.UPDATING}>
                            <CreditAppraisalDateOfAppointment
                                dateOfAppointment={
                                    this.props.caseDetailFields &&
                                    this.props.caseDetailFields.get("date_of_appointment")
                                }
                                isRiskApprover={this.props.isRiskApprover}
                                update={this.onDateAppointmentChange}
                                isUserAllowedToEdit={isUserAllowedToEdit}
                                recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                            />
                        </Spin>
                    </Col>
                    <Col span={5} className={"p-10"}>
                        <Spin spinning={this.props.caseDetailFieldsStatus === STATE_STATUS.FETCHING || this.props.caseDetailFieldsStatus === STATE_STATUS.UPDATING}>
                            <CreditAppraisalDateOfIncorporation
                                dateOfIncorporation={
                                    this.props.caseDetailFields &&
                                    this.props.caseDetailFields.get("date_of_incorporation")
                                }
                                noPermissionRequired={true}
                                isRiskApprover={this.props.isRiskApprover}
                                update={this.onDateIncorporationChange}
                                isUserAllowedToEdit={isUserAllowedToEdit}
                                recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                            />
                        </Spin>
                    </Col>
                   {<GSTFillingStatus
                        companyId={this.props.companyId}
                        gstin={this.props.company.gstin}
                        gstinFillingDetails={this.props.gstinFillingDetails}
                        fetch={this.props.fetchCompanyGstinFillingDetails}
                        refresh={this.props.refreshCompanyGstinFillingDetails}
                        latestDateOfFilling={this.props.company.date_of_gstin_return_filing}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    />}
                </Row>
                {this.props.caseDetail && [3,9].includes(this.props.caseDetail.get('business_product_type')) && 
                 this.props.caseDetail.get('is_bnpl_case') && 
                 <Row>
                    <Col className={"p-10"}>
                        <WctlBlFields caseId={this.props.caseId} values={ksfTLFormData}/> 
                    </Col>                   
                </Row>
                }
                <Col span={24} className={"p-10"}>
                    {![130090, 141834].includes(this.props.caseId) && (
                        <>
                            {this.renderLimitInfoCard()}
                            <span style={{ display: "block", height: 15 }}></span>
                        </>
                    )}
                    <LedgerMasterData
                        caseId={this.props.caseId}
                        company={this.props.company}
                        caseDetail={this.props.caseDetail}
                        gstin={this.props.gstin}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    />
                </Col>
                <Col span={24} className={"p-10"}>
                    <BundledLimitAssignment
                        caseId={this.props.caseId}
                        onSave={this.updateChildCaseLimit}
                        childLimit={this.props.caseDetail.get("bundled_limit_percentage")}
                        stageId={this.props.stageId}
                        userGroup={this.props.userGroup}
                    />
                </Col>
                <Col span={24} className={"p-10"}>
                    <CibilReportTable
                        stageId={this.props.stageId}
                        permission={UI_PERMISSIONS.CIBIL_VIEW}
                        companyId={companyId}
                        status={
                            companyStatus &&
                            companyStatus.get("cibilStatus")
                        }
                        caseId={caseId}
                        associates={this.getAssociatesData()}
                        update={this.updateCaseAssociates}
                        attachDocument={this.props.attachDocument}
                        isUserAllowedToEdit={isUserAllowedToEdit}
                        cibilDocuments={this.state.cibilDocuments}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    />
                </Col>
                <Col span="24" className={"p-10"}>
                {this.props.stageId != 7 && <ApprovalParameters
                    stageId={this.props.stageId}
                    cibilParamData={this.state.cibilParameter}
                    update={this.updateCibilParameter}
                />}
                </Col>
                <Col span="24" className={"p-10"}>
                 {this.props.stageId != 7 &&  <OverdueAccountDetails
                        caseId={caseId}
                    />}
                </Col>
                <Col span={24} className={"p-10"}>
                    {
                        this.props.stageId != 7 && <CibilParamTable
                            cibilParamData={this.state.cibilParameter}
                            company={this.props.company}
                            caseDetails={this.props.caseDetail}
                            update={this.updateCibilParameter}
                            recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                        />
                    }
                </Col>
                <Col span={24} className={"p-10"}>
                    {
                        <Trackwizz
                            trackwizzData={this.state.trackwizzData}
                        />
                    }
                </Col>
                <Col span={24} className={"p-10"}>
                    {
                        <TrackwizzContinuousScreening
                            data={this.state.trackwizzContinuousScreeningData}
                            caseId={this.props.caseId}
                        />
                    }
                </Col>
                {this.props.permissionContext.get("credit_appraisal_bank_statement_analysis_view") ? (
                    <Col span={12} className={"p-10"}>
                        <ExistingBankLimitsList
                            companyId={companyId}
                            status={
                                companyStatus &&
                                companyStatus.get("bankAccountsStatus")
                            }
                            isRiskApprover={this.props.isRiskApprover}
                            bank_accounts={company.bank_accounts}
                            associates={company.associates}
                            update={updateCompanyBankAccounts}
                            isUserAllowedToEdit={isUserAllowedToEdit}
                            recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                        />
                        {this.props.stageId != 7 && <Card
                            title={"Update Loan Track"}
                            className={"padless-card small-card-title"}
                            style={{
                                marginTop: "10px"
                            }}
                            size={"small"}
                            extra={[
                                <Button key="save" type={"link"} disabled={this.props.recreditViewOnlyPermission} onClick={this.updateLoanTrack}> Update </Button>
                            ]}
                        >
                            <Select
                                value={this.state.loan_track}
                                style={{
                                    padding: "10px",
                                    minWidth: "300px"
                                }}
                                placeholder={"Select Loan Track"}
                                onSelect={(val) => {
                                    this.setState({
                                        loan_track: val
                                    });
                                }}
                            >
                                {LOAN_TRACK_OPTIONS.map((_, k) => (
                                    <Select.Option value={_} key={_}>
                                        {k}
                                    </Select.Option>
                                )).toList().toArray()}
                            </Select>
                        </Card>}
                        {this.props.stageId != 7 && <Card
                            title={"Potential Risk"}
                            className={"padless-card small-card-title"}
                            style={{
                                marginTop: "10px"
                            }}
                        >
                            <div className="d-flex flex-column mt-10 mb-10 mr-10">
                                <div className="d-flex justify-content-space-around">
                                    <Select
                                        showSearch
                                        style={{ width: "50%" }}
                                        mode="multiple"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        value={this.state.riskParameter}
                                        placeholder={"Select Risk Parameter"}
                                        onChange={this.onSelectRiskParam}
                                    >
                                        {POTENTIAL_RISK_PARAMETERS.map((_, k) => (
                                            <Select.Option value={_} key={_}>
                                                {k}
                                            </Select.Option>
                                        )).toList().toArray()}
                                    </Select>
                                    <TextArea
                                        placeholder="Remarks"
                                        className="mb-10"
                                        style={{ width: "40%" }}
                                        value={this.state.remarksPotentialRisk}
                                        onChange={(e) => {
                                            if (e.target.value.length < 1000) {
                                                this.setState({ remarksPotentialRisk: e.target.value })
                                            } else {
                                                message.error("Remarks length cannot be greater than 1000");
                                            }
                                        }}
                                    />
                                </div>
                                <div className="d-flex justify-content-flex-end">
                                    <Button disabled={![7, 8, 20].includes(this.props.stageId)} 
                                            type={"primary"} size={"small"} onClick={this.potentialRiskFn}>
                                                Submit
                                    </Button>
                                </div>
                            </div>
                        </Card>}
                        <Card
                            title="Assessment Report"
                            className="padless-card small-card-title"
                            style={{ marginTop: "10px" }}
                            extra={[
                                <Button loading={this.state.downloadExcelLoader} type="link" onClick={() => this.downloadExcel()}>Download Excel</Button>,
                                <Button
                                type="primary"
                                size="small"
                                onClick={this.assessmentInputsFn}
                            >
                                Submit
                            </Button>
                            ]}
                        >
                            <div className="d-flex flex-column m-10">
                                <div className="d-flex flex-row justify-content-space-between">
                                <div className="d-flex flex-column justify-content-center w-90">
                                    <h4>Commercial Bureau Score</h4>
                                    <Input
                                        placeholder="Commercial Bureau Score (if applicable)"
                                        className="mb-10"
                                        style={{ width: "75%" }}
                                        value={this.state.assessmentInputs?.commercialBureauScore ?? Number(this.props.json_data?.cmr_score) ?? ""}
                                        onChange={(e) => this.onChangeAssessmentFields(e.target.value ,"commercialBureauScore")}
                                    />
                                </div>
                                <div className="d-flex flex-column justify-content-center w-90">
                                    <h4>Overlimit in CC/OD</h4>
                                    <Input
                                        placeholder="Overlimit in CC/OD"
                                        className="mb-10"
                                        style={{ width: "75%" }}
                                        value={this.state.assessmentInputs?.overlimitCCOD ?? Number(this.props.json_data?.overlimit_cc_od) ?? ""}
                                        onChange={(e) => this.onChangeAssessmentFields(e.target.value, "overlimitCCOD")}
                                    />
                                </div>
                                
                                
                                </div>
                                <div className="d-flex flex-row justify-content-space-between">
                                <div className="d-flex flex-column justify-content-center w-50">
                                    <h4>Customer Initiated Transactions</h4>
                                    <Input
                                        placeholder="Customer Initiated transactions last 6 months"
                                        className="mb-10"
                                        style={{ width: "75%" }}
                                        value={this.state.assessmentInputs?.customerTransactions ?? Number(this.props.json_data?.customer_initiated_txn_in_last_6_months) ?? ""}
                                        onChange={(e) => this.onChangeAssessmentFields(e.target.value, "customerTransactions")}
                                    />
                                </div>
                                    <div className="d-flex flex-column justify-content-center w-50">
                                        <h4>Anchor Payments Via Banking Debit Match</h4>
                                        {/* <Input
                                            placeholder="Anchor Payments Via Banking Debit Match"
                                            className="mb-10"
                                            style={{ width: "75%" }}
                                            value={this.state.assessmentInputs?.banking_turnover_stated_with_anchor_purchase ?? Number(this.props.json_data?.banking_turnover_stated_with_anchor_purchase) ?? ""}
                                            onChange={(e) => this.onChangeAssessmentFields(e.target.value, "banking_turnover_stated_with_anchor_purchase")}
                                        /> */}
                                        <InputNumber
                                            min={1}
                                            max={100}
                                            step={0.1}
                                            formatter={(value) => `${value}%`}
                                            parser={(value) => value.replace('%', '')}
                                            placeholder="Anchor Payments Via Banking Debit Match"
                                            className="mb-10"
                                            style={{ width: "75%" }}
                                            value={
                                                this.state.assessmentInputs?.banking_turnover_stated_with_anchor_purchase ??
                                                Number(this.props.json_data?.banking_turnover_stated_with_anchor_purchase) ??
                                                undefined
                                            }
                                            onChange={(value) =>
                                                this.onChangeAssessmentFields(value, "banking_turnover_stated_with_anchor_purchase")
                                            }
                                        />
                                    </div>
                                {/* <div className="d-flex justify-content-flex-end">
                                   
                                </div> */}
                                </div>                                
                            </div>
                        </Card>
                    </Col>
                ) : null}
                <Col span={12} className={"p-10"}>
                    <SalesDataList
                        permission={UI_PERMISSIONS.SALES_DATA_VIEW}
                        financial_data={this.props.financials}
                        financial_years={this.props.financialYears}
                        updateTotalSales={this.updateTotalSales}
                        caseDetails={this.props.caseDetail}
                        isUserAllowedToEdit={isUserAllowedToEdit}
                        companyDetail={this.props.company}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    />
                </Col>
                <Col span={12} className={"p-10"}>
                    <Table
                        bordered
                        className="components-table-demo-nested p-10 ant-col padless-card"
                        dataSource={this.state.gstSlabData}
                        columns={columns}
                        pagination={false}
                    />
                </Col>
                <Col span={24} className={"p-10"}>
                    <BankStatementAnalysisTab
                        cibilParamData={this.state.cibilParameter}
                        updateCibilParameter={this.updateCibilParameter}
                        caseId={caseId}
                        lendingPartner={this.props.lendingPartner}
                        companyId={companyId}
                        statements={statements}
                        isRiskApprover={this.props.isRiskApprover}
                        accounts={company.bank_accounts}
                        createStatement={createStatement}
                        deleteStatement={deleteStatement}
                        fetchStatement={fetchStatement}
                        updateStatement={updateStatement}
                        isUserAllowedToEdit={isUserAllowedToEdit}
                        permission={UI_PERMISSIONS.BANK_STATEMENT_ANALYSIS_VIEW}
                        limit={this.getTotalLimit()}
                        type="inner"
                        updateCaseDetail={this.props.updateCaseDetail}
                        updateCaseDetailFields={this.props.updateCaseDetailFields}
                        caseDetail={this.props.caseDetail}
                        use_statement_analyzer={
                            this.props.caseDetailFields
                                ? this.props.caseDetailFields.get("use_statement_analyzer")
                                : this.props.use_statement_analyzer
                        }
                        createRequest={this.props.createRequest}
                        createProfiosRequest={this.props.createProfiosRequest}
                        fetchJobsList={this.props.fetchJobsList}
                        fetchJobsDetails={this.props.fetchJobsDetails}
                        fetchJobsDetailsPerfios={this.props.fetchJobsDetailsPerfios}
                        fetchStatementAnalysis={this.props.fetchStatementAnalysis}
                        fetchStatementAnalysisPerfois={this.props.fetchStatementAnalysisPerfois}
                        retryAnalysis={this.props.retryAnalysis}
                        retryAnalysisPerfios={this.props.retryAnalysisPerfios}
                        bankStatementAnalyser={this.props.bankStatementAnalyser}
                        bankCode={this.props.bankCode}
                        adminGroup={this.props.adminGroup}
                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                    />
                </Col>
                {this.props.caseType === 2 && <Col span={24} className={"p-10"}>
                    <Card
                        title={"Enhancement Policy Parameters"}
                        className={"padless-card"}
                    >
                        <Table
                            bordered
                            className="components-table-demo-nested p-10 ant-col padless-card"
                            columns={columnsEnhancementPolicyPara}
                            dataSource={this.state.dataEnhancementPolicyPara}
                            size="middle"
                            loading={this.state.loading}
                            pagination={false}
                        />
                    </Card>
                </Col>}
                <Col span={24} className={"p-10"}>
                    <SalesAnalysisTradeYear
                        displayYear={String(
                            this.props.caseDetail &&
                            this.props.caseDetail.get(
                                "sales_analysis_display_type"
                            )
                        )}
                        permissionContext={this.props.permissionContext}
                        displayCurrency={String(
                            this.props.caseDetail &&
                            this.props.caseDetail.get(
                                "sales_analysis_display_currency"
                            )
                        )}
                        onSalesDisplayChange={this.onSalesDisplayChange}
                        financials={this.props.financials}
                        financialsStatus={this.props.financialsStatus}
                        fetch={this.props.fetchCaseSupplyChainFinancials}
                        caseId={this.props.caseId}
                        isUserAllowedToEdit={isUserAllowedToEdit}
                        callApis={this.callApis}
                    />
                </Col>
                <Col span={24} className={"p-10"}>
                    <TotalRepayment
                        caseId={this.props.caseId}
                    />
                </Col>
                {this.props.caseDetail.is_financial_analysis_applied ? (
                    <Col span={24} className={"p-10"}>
                        <Card>
                            <div
                                className={
                                    "d-flex justify-content-space-between"
                                }
                            >
                                <h3>Go to Financial Analysis Tab</h3>
                                <Button
                                    onClick={() =>
                                        this.props.onTabChange(
                                            "Financial Analysis"
                                        )
                                    }
                                >
                                    {"Financial Analysis"}
                                </Button>
                            </div>
                        </Card>
                    </Col>
                ) : null}
                {this.props.caseDetail && this.props.caseDetail.bank&&
                    ["KSF|HHPL", "HHPL"].includes(this.props.caseDetail.bank.code) &&
                    this.props.caseDetail.scheme_type == "Term Loan" &&
                    <EligibilityCalculator
                        calculatorData={this.state.calculatorData}
                        financialsData={this.props.financials && this.props.financials.get('data')}
                        caseId={this.props.caseId}
                        isKSFTl={this.props.caseDetail && this.props.caseDetail.bank &&
                            this.props.caseDetail.bank.code == "KSF|HHPL" && this.props.caseDetail.scheme_type == "Term Loan"}
                        bankStatementAnalyser={this.props.bankStatementAnalyser}
                        caseDetail={this.props.caseDetail}
                    />}
                {this.props.permissionContext.get("credit_appraisal_bank_statement_analysis_view") ?
                    (
                        <React.Fragment>
                            <Col span={24} className={"p-10"}>
                                <RemarksEditor
                                    loading={this.props.remarksStatus == STATE_STATUS.FETCHING}
                                    getCaseRemarks={this.getCaseRemarks}
                                    remarks={this.props.caseDetail.remarks}
                                    onEdit={this.onRemarksEdit}
                                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                    stageId={this.props.stageId}
                                    thisUser={this.props.thisUser}
                                    currentStageUser={this.props.currentStageUser}
                                />
                            </Col>
                            <Col span={24} className={"p-10"}>
                                <InnerRemarksEditor
                                    loading={this.props.remarksStatus == STATE_STATUS.FETCHING}
                                    getCaseRemarks={this.getCaseRemarks}
                                    remarks={this.props.caseInternalRemarks}
                                    onEdit={this.onInnerRemarksEdit}
                                    isUserAllowedToEdit={this.props.isUserAllowedToEdit}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                    stageId={this.props.stageId}
                                    thisUser={this.props.thisUser}
                                    currentStageUser={this.props.currentStageUser}
                                />
                            </Col>
                            <Col span={24} className={"p-10"}>
                                <TopBrandsTable
                                    caseId={this.props.caseId}
                                    channelProductStats={this.props.channelProductStats}
                                    channelProductStatsStatus={this.props.channelProductStatsStatus}
                                    updateBrands={this.updateBrands}
                                    isUserAllowedToEdit={isUserAllowedToEdit}
                                    products={this.state.channel_products}
                                    addNewChannelProduct={this.props.addNewChannelProduct}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            </Col>
                            {this.props.stageId != 7 && <Col span={24} className={"p-10"}>
                                <ReCreditParameterTable
                                    dataSource={this.state.reCreditParams}
                                />
                            </Col>}
                        </React.Fragment>
                    ) : null
                }
            </Row>
        );
    }
}

CreditAppraisalTab.propTypes = {
    caseId: PropTypes.number,
    caseDetail: PropTypes.object,
    supplyChainDetail: PropTypes.object,
    updateCompanyAssociates: PropTypes.func,
    updateCompanyBankAccounts: PropTypes.func,
    companyId: PropTypes.number,
    company: PropTypes.object,
    companyStatus: PropTypes.object,
    statements: PropTypes.object,
    createStatement: PropTypes.func,
    fetchStatement: PropTypes.func,
    updateStatement: PropTypes.func,
    deleteStatement: PropTypes.func,
    proposed_limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    financials: PropTypes.object,
    financialsStatus: PropTypes.string,
    fetchCaseSupplyChainFinancials: PropTypes.func,
    updateCaseDetail: PropTypes.func,
    fetchFinancialYears: PropTypes.func,
    financialYearsStatus: PropTypes.string,
    financialYears: PropTypes.object,
    history: PropTypes.object,
    onTabChange: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    channelProductStats: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    channelProductStatsStatus: PropTypes.string,
    fetchChannelProductStats: PropTypes.func,
    updateChannelProductStats: PropTypes.func,
    updateCaseRemarks: PropTypes.func,
    permissionContext: PropTypes.object,
    isUserAllowedToEdit: PropTypes.bool,
    caseRemarks: PropTypes.string,
    caseInternalRemarks: PropTypes.string,
    addNewChannelProduct: PropTypes.func,
    updateCompanyAssociatesCibil: PropTypes.func,
    gstin: PropTypes.string,
    fetchCompanyGstinFillingDetails: PropTypes.func,
    refreshCompanyGstinFillingDetails: PropTypes.func,
    gstinFillingDetails: PropTypes.object,
    attachDocument: PropTypes.func,
    lendingPartner: PropTypes.number,
    createRequest: PropTypes.func,
    createProfiosRequest: PropTypes.func,
    fetchJobsList: PropTypes.func,
    fetchJobsDetails: PropTypes.func,
    fetchJobsDetailsPerfios: PropTypes.func,
    fetchStatementAnalysis: PropTypes.func,
    fetchStatementAnalysisPerfois: PropTypes.func,
    retryAnalysis: PropTypes.func,
    retryAnalysisPerfios: PropTypes.func,
    bankStatementAnalyser: PropTypes.object,
    adminGroup: PropTypes.object,
    use_statement_analyzer: PropTypes.bool,
    caseAssociates: PropTypes.array,
    addCaseAssociates: PropTypes.func,
    bankCode: PropTypes.string,
    caseType: PropTypes.number,
    recreditViewOnlyPermission: PropTypes.bool,
    remarksStatus: PropTypes.string,
    thisUser: PropTypes.string,
};

const mapStateToProps = (state, props) => ({
    company: state.companies.getIn([props.companyId, "data"]),
    companyStatus: state.companies.getIn([props.companyId, "status"]),
    statements: state.statements.get(props.caseId),
    channelProductStatsStatus: state.caseDetails.getIn([props.caseId, "channelProductStats", "status"]),
    channelProductStats: state.caseDetails.getIn([props.caseId, "channelProductStats", "data"]),
    proposed_limit: state.caseDetails.getIn([
        props.caseId,
        "data",
        "proposed_limit"
    ]),
    financials: state.supplyChain.getIn(["financials", props.caseId, "data"]),
    financialsStatus: state.supplyChain.getIn([
        "financials",
        props.caseId,
        "status"
    ]),
    financialYearsStatus: state.financials.get("financialYearsStatus"),
    financialYears: state.financials.get("financialYears"),
    caseRemarks: state.caseDetails.getIn([props.caseId, "data", "remarks"]),
    caseInternalRemarks: state.caseDetails.getIn([props.caseId, "data", "internal_remarks"]),
    gstin: state.companies.getIn([props.companyId, "data", "gstin"]),
    gstinFillingDetails: state.gstinDetails.get(state.companies.getIn([props.companyId, "data", "gstin"])) || Map({
        status: STATE_STATUS.UNFETCHED,
        data: List([])
    }),
    lendingPartner: state.caseDetails.getIn([props.caseId, "data", "bank", "id"]),
    bankStatementAnalyser: state.bankStatementAnalyser.get(props.caseId),
    use_statement_analyzer: state.caseDetails.getIn([props.caseId, "data", "use_statement_analyzer"]),
    caseAssociates: state.caseDetails.getIn([props.caseId, "caseAssociates", "data"]),
    bankCode: state.caseDetails.getIn([props.caseId, "data", "bank", "code"]),
    dateOfIncorporationEdit: state.user.get("permissions"),
    adminGroup: state.user.getIn(["data", "stage_admin"]),
    thisUser: state.user.getIn(["data", "id"]),
    currentStageUser: state.caseDetails.getIn([props.caseId, "data", "current_case_task"]),
    userGroup: state.user.getIn(["data", "groups"]),
    caseType: state.caseDetails.getIn([props.caseId, "data", "case_type"]),
    json_data: state.caseDetails.getIn([props.caseId, "data", "json_data"]),
    remarksStatus: state.caseDetails.getIn([props.caseId, "remarksStatus"] , STATE_STATUS.UNFETCHED),
    caseDetailFields: state.caseDetails.getIn([props.caseId, "caseDetailFields", "data"]),
    caseDetailFieldsStatus: state.caseDetails.getIn([props.caseId, "caseDetailFields", "status"], STATE_STATUS.UNFETCHED)

});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateCompanyAssociates,
            updateCompanyBankAccounts,
            createStatement,
            fetchStatement,
            updateStatement,
            deleteStatement,
            fetchCaseSupplyChainFinancials,
            updateCaseDetail,
            fetchCaseDetailFields,
            updateCaseDetailFields,
            fetchFinancialYears,
            fetchChannelProductStats,
            updateChannelProductStats,
            updateCaseRemarks,
            addNewChannelProduct,
            updateCompanyAssociatesCibil,
            fetchCompanyGstinFillingDetails,
            refreshCompanyGstinFillingDetails,
            attachDocument,
            createRequest,
            createProfiosRequest,
            fetchJobsList,
            fetchJobsDetails,
            fetchJobsDetailsPerfios,
            fetchStatementAnalysis,
            fetchStatementAnalysisPerfois,
            retryAnalysis,
            retryAnalysisPerfios,
            addCaseAssociates,
            fetchCaseRemarks
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreditAppraisalTab);
